import { Component } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { AppComponent } from '../../../../../apps/supplier-portal/src/app/app.component';

@Component({
  selector: 'boma-app-right-menu',
  templateUrl: './app-right-menu.component.html',
  styleUrls: ['./app-right-menu.component.scss'],
})
export class AppRightMenuComponent {
  amount: SelectItem[];

  selectedAmount: any;

  constructor(public appMain: AppComponent) {
    this.amount = [
      { label: '*****24', value: { id: 1, name: '*****24', code: 'A1' } },
      { label: '*****75', value: { id: 2, name: '*****75', code: 'A2' } },
    ];
  }
}
